import { Layout } from "antd";
import styled from "@emotion/styled";
export const FullHeightLayout = styled(Layout)`
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: linear-gradient(180deg, #a78bfa 0%, #86efac 100%);
  .ant-btn-primary {
    border-radius: 10px;
    height: 46px;
    font-size: 0.95rem;
    font-weight: 700;
    background: linear-gradient(90deg, #7b3bea 0%, #28c665 100%);
  }
  .right-header {
    margin-bottom: 32px;

    h2 {
      font-size: 1.6rem;
      font-weight: 800;
      color: #111827;
      letter-spacing: -0.4px;
      margin-bottom: 6px;
    }

    p {
      font-size: 0.875rem;
      color: #6b7280;
      line-height: 1.5;
    }
  }

  .card-div {
    display: flex;
    width: 100%;
    max-width: 900px;
    min-height: 560px;
    background: #fff;
    border-radius: 24px;
    overflow: hidden;
    box-shadow:
      0 32px 80px rgba(123, 59, 234, 0.12),
      0 8px 24px rgba(0, 0, 0, 0.06);

    &.signup-card {
      max-width: 1000px;
    }
    /* ── LEFT PANEL ── */
    .auth-left {
      position: relative;
      width: 400px;
      flex-shrink: 0;
      background: linear-gradient(
        145deg,
        var(--primary) 0%,
        #5a1ec9 60%,
        #3d0fa8 100%
      );
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 40px 36px;
      overflow: hidden;

      /* subtle grid overlay */
      &::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image:
          linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
        background-size: 32px 32px;
        pointer-events: none;
      }

      /* glowing orb */
      &::after {
        content: "";
        position: absolute;
        bottom: -80px;
        right: -80px;
        width: 260px;
        height: 260px;
        border-radius: 50%;
        background: radial-gradient(
          circle,
          rgba(255, 255, 255, 0.12) 0%,
          transparent 70%
        );
        pointer-events: none;
      }

      .left-top {
        position: relative;
        z-index: 1;
      }

      .logo-wrap {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 36px;

        img {
          width: 44px;
          height: 44px;
          object-fit: contain;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.15);
          padding: 6px;
        }

        .brand-name {
          font-size: 1.1rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.2px;
          line-height: 1.2;

          span {
            display: block;
            font-size: 0.7rem;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.6);
            letter-spacing: 1.2px;
            text-transform: uppercase;
          }
        }
      }

      h1 {
        font-size: 1.75rem;
        font-weight: 800;
        color: #fff;
        line-height: 1.25;
        margin-bottom: 14px;
        letter-spacing: -0.5px;
      }

      .accent-line {
        width: 48px;
        height: 3px;
        border-radius: 99px;
        background: rgba(255, 255, 255, 0.45);
        margin-bottom: 16px;
      }

      .left-desc {
        font-size: 0.875rem;
        line-height: 1.65;
        color: rgba(255, 255, 255, 0.72);
      }

      .left-bottom {
        position: relative;
        z-index: 1;
      }

      .feature-pills {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 40px;
      }

      .pill {
        display: flex;
        align-items: center;
        gap: 10px;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 10px;
        padding: 10px 14px;
        backdrop-filter: blur(4px);

        .pill-icon {
          width: 40px;
          height: 40px;
          border-radius: 7px;
          background: rgba(255, 255, 255, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 18px;
        }

        .pill-text {
          font-size: 15px;
          font-weight: 500;
          color: #fff;
          line-height: 1.3;

          span {
            display: block;
            font-size: 13px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
    .auth-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 48px 44px;

      @media (max-width: 900px) {
        padding: 40px 32px;
      }
    }
  }
  @media (max-width: 768px) {
    .card-div {
      flex-direction: column;
      max-width: 500px;
      min-height: unset;
      border-radius: 20px;
    }
    .auth-left {
      width: 100% !important;
      padding: 36px 28px 32px;
    }
    .left-bottom,
    /* .sub-title, */
    .accent-line,
    .left-desc {
      display: none;
    }
    .logo-wrap {
      margin-bottom: 10px !important;
    }
    .sub-title {
      margin-bottom: 0px !important;
      font-size: 20px !important;
    }
    .auth-right {
      padding: 32px 28px 36px;
    }
  }
`;
